import { useState } from "react";
import "../../assets/css/outbound.css";
import ReusableFileUploadModal from "./ReusableFileUploadModal";

const MediaUploadIconWrapper = (props) => {
  const { fileList, setFileList, integId, skipFilter, showMMS, className = "", iconsSize = "large", contactId } = props;
  const [isUploadModalVisible, setIsUploadModalVisible] = useState();

  return (
    <>
      <ReusableFileUploadModal
        visible={isUploadModalVisible}
        setVisible={setIsUploadModalVisible}
        setFileList={setFileList}
        fileList={fileList}
        source={"sendsms"}
        integId={integId}
        skipFilter={skipFilter}
        contactId={contactId}
      />
      {showMMS ? (
        <div
          data-cy="attach-file"
          className={`${iconsSize === "small" ? "hs-scale-0-8" : ""} actionIconsSprite conversationPageMediaUploadIcon ${className}`}
          onClick={() => setIsUploadModalVisible(true)}
          style={{ cursor: "pointer" }}
        ></div>
      ) : (
        <div></div>
      )}
    </>
  );
};
export default MediaUploadIconWrapper;
